import React from 'react';

export default class Page extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      src: null
    }
  }

  async componentDidMount() {
    const meta = await this.props.api.meta();
    let path = window.location.pathname;
    let qp = window.location.search;

    if (path === "/") {
      path = "/index.html";
    }
    this.setState({
      src: `https://${this.props.templatesDomain}/${meta.defaultTemplateId}${path}${qp}`
    });
  }


  render() {
    if (this.state.src === null) {
      return null;
    }

    window.location = this.state.src;
    return;

    return (
      <iframe src={this.state.src}
              title="title"
              ref="iframe"
              style={{ width: "100vw", height: "100vh", "border": 0 }}
              frameborder={"0"}
              loading={"eager"}
              marginwidth={"0"}
              marginheight={"0"}
              scrolling={"auto"}

              />
    );
  }


}
